import { render } from "./BaseNavigation.vue?vue&type=template&id=5711136c&scoped=true"
import script from "./BaseNavigation.vue?vue&type=script&lang=js"
export * from "./BaseNavigation.vue?vue&type=script&lang=js"

import "./BaseNavigation.vue?vue&type=style&index=0&id=5711136c&scoped=true&lang=css"

import exportComponent from "/mnt/extra-storage/twiga_front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5711136c"]])

export default __exports__